import {PaymentMethod} from '@stripe/stripe-js'
import {api} from 'lib/url'
import {teamMemberClient} from 'obvio/obvio-client'
import {TeamMember} from 'auth/user'
import {useMutation, useQueryClient} from 'react-query'

export function useSetDefaultPaymentMethod() {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (paymentMethodId: string) => {
      const url = api('/stripe/default_payment_method')
      const result = await teamMemberClient.put<TeamMember | PaymentMethod>(
        url,
        {
          payment_method_id: paymentMethodId,
        },
      )

      if (isTeamMember(result)) {
        return {
          user: result,
          paymentMethod: await teamMemberClient.get<PaymentMethod>(
            api('/stripe/default_payment_method'),
          ),
        }
      }

      return {
        user: null,
        paymentMethod: result,
      }
    },
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: ['stripe', 'payment_methods'],
        exact: true,
      })
    },
  })
}

function isTeamMember(value: TeamMember | PaymentMethod): value is TeamMember {
  return 'has_active_subscription' in value
}
